/**
 * Warm the landing-page chunks so they are in cache by the time the post-login redirect
 * runs. Call it immediately before awaiting a login action, not after: the fetch then
 * overlaps the whole `createToken` + `identify` round trip instead of just the tail of it.
 *
 * This lived inside `src/stores/auth.ts` until 2026-08-19. Vitest's `related` selection
 * follows `import()` exactly like a static edge, so those two specifiers made every spec
 * that reaches the auth store related to the landing page and, through it, most of
 * `src/app` — `--fanout` on LandingPage.vue was 1543 specs, and is 3 with this module in
 * its place. A store may not name a view; a view may.
 */
export function prefetchLandingPage() {
  import('@/app/landingPage/App.vue').catch(() => {});
  import('@/app/landingPage/pages/LandingPage.vue').catch(() => {});
}
